<template lang="pug">
  div
    el-row#card-zoom(type="flex", justify="center")
      el-col(:span="2")
        el-button#iconZoom.zoomOut(@click="zoomOut")
          i.fal.fa-search-minus
      el-col(:span="2")
        h3.zoom {{ this.scaleZoomPorcentagem }}%
      el-col(:span="2")
        el-button#iconZoom.zoomIn(@click="zoomIn")
          i.fal.fa-search-plus
      el-col(:span="2")
        el-button#iconZoom.rotateLeft(@click="rotateLeft")
          i.fal.fa-undo-alt
      el-col(:span="2")
        el-button#iconZoom.rotateRight(@click="rotateRight")
          i.fal.fa-redo-alt
    div#image.card-info(shadow="hover" :style="customStyle || {}")
      app-vue-perfect-scrollbar.scroll-area(v-once='', :settings='settings')
        div
          img#img(:src="imgUrl(bytes)")
</template>

<script>
import AppVuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    AppVuePerfectScrollbar
  },

  props: {
    bytes: {
      required: true,
      type: ArrayBuffer
    },
    customStyle: {
      type: Object
    }
  },

  data () {
    return {
      settings: {
        maxScrollbarLength: 60
      },
      scaleZoomPorcentagem: 100,
      widthImage: null,
      rotationAngle: 0
    }
  },

  methods: {
    async zoomIn () {
      const image = document.getElementById('img')
      this.scaleZoomPorcentagem = await this.scaleZoomPorcentagem + 5

      if (this.widthImage === null) {
        this.widthImage = image.clientWidth
      }

      image.style.width = (this.scaleZoomPorcentagem * this.widthImage) / 100 + 'px'
    },

    async zoomOut () {
      if (this.scaleZoomPorcentagem > 30) {
        const image = document.getElementById('img')

        this.scaleZoomPorcentagem = await this.scaleZoomPorcentagem - 5

        if (this.widthImage === null) {
          this.widthImage = image.clientWidth
        }

        image.style.width = (this.scaleZoomPorcentagem * this.widthImage) / 100 + 'px'
      }
    },

    rotateLeft () {
      this.rotationAngle -= 90
      if (this.rotationAngle < 0) {
        this.rotationAngle += 360
      }
      const image = document.getElementById('img')
      image.style.transform = `rotate(${this.rotationAngle}deg)`
    },

    rotateRight () {
      this.rotationAngle += 90
      if (this.rotationAngle >= 360) {
        this.rotationAngle -= 360
      }
      const image = document.getElementById('img')
      image.style.transform = `rotate(${this.rotationAngle}deg)`
    },

    imgUrl (imagem) {
      const intArray = new Uint8Array(imagem)
      const reducedArray = intArray.reduce((data, byte) => data + String.fromCharCode(byte), '')

      const base64String = `data:image/png;base64, ${btoa(reducedArray)}`

      return base64String
    }

  }

}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/_variables.scss';

#image {
  text-align: center;
  margin: 1%;
  border-radius: 15px;
  height: 500px;
  margin-top: 1rem;
  margin-left: 0px;
  margin-right: 0px;
  border: 1px solid #eaeef1;
  width: 100%;
}

.scroll-area {
  position: relative;
  margin: auto;
  height: 100%;
  background-color: transparent;
  border-radius: 15px;
  border: 1px solid #eaeef1;
}

.card-info {
  border-radius: 15px;
  background-color: #4F4F4F;
  border-color: #eaeef1;
  margin: 2%;
}

#card-zoom {
  margin: 0 auto;
  height: 50px;
  margin: -20px 0 -10px;
}

#iconZoom {
  height: 46px;
  margin-top: 5px;
  margin-bottom: 5px;
  background-color: hsl(0, 0%, 50%);
  border-radius: 5px;
}

.zoomIn {
  margin-left: 5px;
}
.rotateLeft, .rotateRight {
  margin: 0 5px;
}

.zoomOut {
  margin-right: 5px;
  float: right;
}
.zoom {
  text-align: center;
  vertical-align: middle;
  color: #D3D3D3!important;
  background-color: #4F4F4F;
  height: 46px;
  padding-top: 15px;
  margin: 5px auto 5px;
  border-radius: 5px;
  margin-right: 10px;
  margin-left: 10px;
}

.fa-search-minus, .fa-search-plus, .fa-undo-alt, .fa-redo-alt {
  color: #fff;
}

.fa-search-plus {
color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/AppImageViewer.vue